import { Card } from '@ironhack/design-system2/components/card';
import { type FlexProps } from '@ironhack/design-system2/components/flex';
import { Progress } from '@ironhack/design-system2/components/progress';
import { Text } from '@ironhack/design-system2/components/text';
import { type ComponentProps, type ReactElement } from 'react';
import { type StructuredTextGraphQlResponse } from 'react-datocms';

import { StructuredContent } from '@/app/components/client/structured-content';
import { type DatoBlock } from '@/lib/datocms';

export type ProgressFill = ComponentProps<typeof Progress>['variant'];

export type ProgressCard = DatoBlock<{
  content: StructuredTextGraphQlResponse;
  // not optional or undefined because this comes from a hook that defaults null
  progressFill: ProgressFill | null;
  progressLabel: string;
  progressValue: number;
  tabTitle: string;
  title: string;
}>;

type Props = { card: ProgressCard } & FlexProps;

export const ProgressCard = (props: Props): ReactElement => {
  const { card, ...flexProps } = props;
  const { content, progressFill, progressLabel, progressValue, title } = card;

  return (
    <Card p={[2, null, 5]} {...flexProps}>
      <Text color="text.secondary" textStyle="xsBold">
        {`${progressLabel} ${progressValue}%`}
      </Text>
      <Progress
        mt={1}
        value={progressValue}
        variant={progressFill ?? 'default'}
      />
      <Text color="text.primary" mt={2} textStyle="2xl">
        {title}
      </Text>
      <StructuredContent data={content} mt={1} />
    </Card>
  );
};
